// startup
// Load entry module and return exports
__webpack_require__(1246);
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__(5488);
